var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserLocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "currentColor"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_321_6495)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 26V28C22.4087 28 20.8826 28.6321 19.7574 29.7574C18.6321 30.8826 18 32.4087 18 34H16C16 31.8783 16.8429 29.8434 18.3431 28.3431C19.8434 26.8429 21.8783 26 24 26ZM24 25C20.685 25 18 22.315 18 19C18 15.685 20.685 13 24 13C27.315 13 30 15.685 30 19C30 22.315 27.315 25 24 25ZM24 23C26.21 23 28 21.21 28 19C28 16.79 26.21 15 24 15C21.79 15 20 16.79 20 19C20 21.21 21.79 23 24 23ZM33 29H34V34H26V29H27V28C27 27.2044 27.3161 26.4413 27.8787 25.8787C28.4413 25.3161 29.2044 25 30 25C30.7956 25 31.5587 25.3161 32.1213 25.8787C32.6839 26.4413 33 27.2044 33 28V29ZM31 29V28C31 27.7348 30.8946 27.4804 30.7071 27.2929C30.5196 27.1054 30.2652 27 30 27C29.7348 27 29.4804 27.1054 29.2929 27.2929C29.1054 27.4804 29 27.7348 29 28V29H31Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_321_6495"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLocked);
export default __webpack_public_path__ + "static/media/user-locked.b62af71fb3faa8aac92f10b7c8267708.svg";
export { ForwardRef as ReactComponent };